<template>
    <div class="container flex-grow-1 align-content-center d-flex align-items-center">
        <div class="text-center flex-grow-1 align-items-center d-flex flex-column">
            <div class="looping-rhombuses-spinner mb-3" style="padding-top: 30px; padding-bottom: 30px; max-height: 60px">
                <div class="rhombus"></div>
                <div class="rhombus"></div>
                <div class="rhombus"></div>
            </div>
            <h4 class="text-muted text-bold">We&rsquo;re Sorry</h4>
            <div class="text-muted small">{{message}}</div>
            <div class="text-muted small mt-3" v-if="checkPerformed">If this error persists, please contact technical support.</div>
            <button type="button" class="btn btn-small btn-secondary mt-2" @click="handleReload">Reload</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ErrorPanel',
    props: {
        message: {
            type: String,
            default: 'Error',
        },
    },
    computed: {
        checkPerformed() {
            return (location.search || '').indexOf('retryAttempted') >= 0;
        },
    },
    methods: {
        handleReload() {
            if (this.checkPerformed) {
                window.location.reload();
            }
            else {
                window.location += '?retryAttempted=1';
            }
        },
    },
};
</script>